(function($){

    var initializeBlock = function( $block ) {
        //console.log('accordion-js');
    };

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.wpk-block-accordion').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=accordion', initializeBlock );
    }

})(jQuery);